
import { baseApi } from "./baseApi"

const COLLECTION_BASE_URL = "/shipmentFDs"
const shipmentFulfillmentDocumentApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    AddShipmentFD: builder.mutation({
      query: (payLoad) => ({
        url: COLLECTION_BASE_URL,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "ShipmentFD", id: _id },
        { type: "ShipmentFD", id: "LIST" },
      ],
    }),

    listShipmentFD: builder.query({
      query: (params) => ({
        url: COLLECTION_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "ShipmentFD", _id })),
            { type: "ShipmentFD", id: "LIST" },
          ]
          : [{ type: "ShipmentFD", id: "LIST" }],
    }),

    getDDLShipmentFDList: builder.query({
      query: (params) => ({ url: `${COLLECTION_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "ShipmentFD", _id })),
            { type: "ShipmentFD", id: "DDL" },
          ]
          : [{ type: "ShipmentFD", id: "DDL" }],
    }),

    getShipmentFDDetail: builder.query({
      query: (shipmentFDId) => `${COLLECTION_BASE_URL}/${shipmentFDId}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "ShipmentFD", _id },
        { type: "ShipmentFD", id: "LIST" },
      ],
    }),

    updateShipmentFD: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${COLLECTION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "ShipmentFD", id },
        { type: "ShipmentFD", id: "LIST" },
      ],
    }),
  })
})






export const {
  useAddShipmentFDMutation,
  useListShipmentFDQuery,
  useLazyListShipmentFDQuery,
  useLazyGetDDLShipmentFDListQuery,
  useLazyGetDDLShipmentFDQuery,
  useGetShipmentFDDetailQuery,
  useUpdateShipmentFDMutation,

} = shipmentFulfillmentDocumentApi;